import { DocumentNode } from 'apollo-link';

import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const TableDownstreamMetricsFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamMetricsFilteredByColumnQuery($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
